import { Exclude, Expose, Type } from 'class-transformer';
import { BasicData } from './BasicData';
import { BasicList } from './BasicList';

class Data extends BasicData {}

Exclude();
export class List extends BasicList {
    @Expose()
    @Type(() => Data)
    data: Data[];
}
